import { MessageType } from "../constant/message-type.constant";

export class Message {
  constructor(
    public code: string,
    public type: MessageType,
    public text: string
  ) {}
}
